import { CommonModule, isPlatformBrowser, LowerCasePipe } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { FooterComponent } from '../landing/footer/footer.component';
import { Router, RouterLink } from '@angular/router';
import { NgFor, NgForOf, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { PartnersComponent } from '../landing/partners/partners.component';
import { FuseCardComponent } from '@fuse/components/card';
import { MatIconModule } from '@angular/material/icon';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';
import { GtmService } from 'app/core/shared-services/gtm.service';




@Component({
  selector: 'app-catalog',
  standalone: true,
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss'],
  imports: [
    CommonModule, FooterComponent, RouterLink, NgFor, NgForOf, NgIf, 
    MatButtonModule, PartnersComponent, LowerCasePipe, FuseCardComponent,
    MatIconModule
  ],
})
export class CatalogComponent implements OnInit {

  public catalog: any;
  public catalogHeader: any;
  public catalogHeaderImage: any;
  public catalogHeaderText: string;
  public catalogHeaderTitle: string;
  public headerTextColor: string;

  private isScreenSmall: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  private referrer: string;

  /**
     * Constructor
  **/

  constructor(
    private _strapiService: StrapiService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _gtmService: GtmService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any

)
{
}

// -----------------------------------------------------------------------------------------------------
// @ Lifecycle hooks
// -----------------------------------------------------------------------------------------------------
/**
 * On init
 */
ngOnInit(): void
  {

    if (isPlatformBrowser(this.platformId)) {
      
      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

      const route = window.location.href;
      const path = this.router.url;
      this._gtmService.pushEvent({ 
        event: 'page_view',
        page_url: route,
        page_path: path,
        page_title: 'product_overview_page',
        page_referrer: this.referrer ? this.referrer : route
      });
    }
    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(({matchingAliases}) =>
    {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
    });

    // get content from Strapi
    this._strapiService.getCatalogScreenContent()
    .subscribe({
        next: (res: any) => {
            this.catalog = res.data.sort((b) => {b.renderPriority - b.renderPriority});
        }
    });

    // get content from Strapi
    this._strapiService.getCatalogScreenHeaderContent()
    .subscribe({
        next: (res: any)  => {
          if(this.isScreenSmall) {
            this.catalogHeaderImage = res.data.mobileImage.url;
          } else {
            this.catalogHeaderImage = res.data.image.url;
          }
            this.catalogHeaderText = res.data.description;
            this.catalogHeaderTitle = res.data.title;
            this.headerTextColor = res.data.text_color_hex;
        }
    });
  }

  /**
     * On destroy
     */
  ngOnDestroy(): void
  {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
  }
}
